export enum FeatureToggle {
  PromotedPlacements = 'rt_promoted_placements',
  MeshGetStorefrontPlacements = 'mesh_get_storefront_placements',
  EnterpriseI18nHeroBanners = 'rt_enterprise_i18n_hero_banners',
  PromotedPlacementsExternalUrl = 'rt_promoted_placements_external_url',
}
